// appConfigSlice.js
import { createSlice } from "@reduxjs/toolkit";

const storedClientId = localStorage.getItem("selectedClientId");
const storedProjectId = localStorage.getItem("selectedProjectId");

const initialState = {
  clients: [],
  projects: [],
  selectedClient: storedClientId || null,
  selectedProject: storedProjectId || null,
};

const clientProjectSlice = createSlice({
  name: "clientProject",
  initialState,
  reducers: {
    setClientProject(state, action) {
      const { clients, projects } = action.payload || {};
      state.clients = clients || [];
      state.projects = projects || [];
      state.selectedClient = clients?.[0]?.id || null;
      state.selectedProject = projects?.[0]?.id || null;
      if(state.selectedClient) {
        localStorage.setItem("selectedClientId", state.selectedClient);
      }
      if(state.selectedProject) {
        localStorage.setItem("selectedProjectId", state.selectedProject);
      }
    },
  },
});

export const { setClientProject } = clientProjectSlice.actions;
export default clientProjectSlice.reducer;